import React from "react";
import useAppNavigate from "../../hooks/useAppNavigate";
import useIsDarkMode from "../../hooks/useIsDarkMode";
import { Forward, forwardArrow } from "../../common/imagePath";

const PageHeader = ({ title, onBack, titleClass = "" }) => {
  const navigate = useAppNavigate();
  const isDarkMode = useIsDarkMode();

  const handleBack = onBack ?? (() => navigate(-1));

  return (
    <div className="flex items-center gap-3 h-[78px] px-4 bg-white border-b dark:bg-[#000000] dark:border-gray-700">
      <button
        onClick={handleBack}
        aria-label="Go back"
        className="active:opacity-60 transition-opacity duration-150"
      >
        <img
          src={isDarkMode ? Forward : forwardArrow}
          alt="Back"
          className="w-5 h-5"
        />
      </button>
      <h1 className={`font-inter font-semibold leading-none tracking-[0px] text-[#1C1C1E] dark:text-white ${titleClass || "text-[18px]"}`}>
        {title}
      </h1>
    </div>
  );
};

export default PageHeader;
